import src from "IMAGE";
export default { src, width: 1808, height: 944, blurWidth: 0, blurHeight: 0};
